import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ToolCapaciteService } from '../../../tool-capacite.service';
import { ToolPreautorisationService } from '../../../../tool-preautorisation/tool-preautorisation.service';
import { StatusCapaciteEnum } from '../../constants/status-capacite.enum';

@Component({
  selector: 'app-conseils-preautorisation',
  templateUrl: './conseils-preautorisation.component.html',
  styleUrls: ['./conseils-preautorisation.component.scss'],
  standalone: false
})
export class ConseilsPreautorisationComponent {
  StatusCapaciteEnum = StatusCapaciteEnum;

  isPreautorisationCoemprunteur$: Observable<boolean> = this.toolPreautorisationService.isCoemprunteur$;
  donneesResultat$: Observable<unknown> = this.toolCapaciteService.donneesResultat$;
  statutCapacite$: Observable<StatusCapaciteEnum> = this.toolCapaciteService.statutCapacite$;
  isCapacityCompleted$: Observable<boolean> = this.toolCapaciteService.isCapacityCompleted$;

  constructor(
    private readonly toolPreautorisationService: ToolPreautorisationService,
    private readonly toolCapaciteService: ToolCapaciteService
  ) {}
}
